/**
 * @generated SignedSource<<64dd1adb3be7c3e6eea86fdbdd48eb7a>>
 * @relayHash c469f27bb95fa45bd475ea723fcf94b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dd5b717801dc78268da5ca4081383ab620c0e1a45f1a4c3365466fafe81fffa0

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useUserPageAccessTypeContentOperationsQuery$variables = {
  id: string;
};
export type useUserPageAccessTypeContentOperationsQuery$data = {
  readonly singleContent: {
    readonly id: string | null | undefined;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null | undefined;
      readonly targetType: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type useUserPageAccessTypeContentOperationsQuery = {
  response: useUserPageAccessTypeContentOperationsQuery$data;
  variables: useUserPageAccessTypeContentOperationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUserPageAccessTypeContentOperationsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserPageAccessTypeContentOperationsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c469f27bb95fa45bd475ea723fcf94b2",
    "id": "dd5b717801dc78268da5ca4081383ab620c0e1a45f1a4c3365466fafe81fffa0",
    "metadata": {},
    "name": "useUserPageAccessTypeContentOperationsQuery",
    "operationKind": "query",
    "text": "query useUserPageAccessTypeContentOperationsQuery($id:ID!){singleContent(id:$id){id,type,operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "75a3d4bc10bc341fe0a2b51ec78f3fee";

export default node;
